module.exports = __webpack_public_path__ + "img/am.15d9b1b3.svg";